module.exports = function() {
  return new Worker(__webpack_public_path__ + "91fe7c59d58432d35cf9.worker.js");
};